import { CancelTokenSource } from 'axios';
import { PageMode } from '@/main/utils/pageMode';

import { DropdownList } from './dropdown.d';


export interface Crumb {
	label: string;
	detail: string | null;
}

export enum Status {
	ok = 'success',
	error = 'error',
}

export interface PageStoreProps {
	mode: PageMode | null,
}

export type TValidationRules = Record<string, any>;

export type PageStoreBase = PageStore<DropdownList, {}, PageStoreProps>;

export interface PageStore<
	TDropdownList extends DropdownList,
	TLocalState extends object,
	TProps extends PageStoreProps,
> {
	crumb: Crumb,
	loadingCount: number;
	mainCollapse: string[];
	activeTabName: string;
	name: string;
	operations: number | null;
	validationRules: TValidationRules | null;
	requestCancelTokens: Record<string, CancelTokenSource | null>;
	refreshPreviousPage: boolean,
	status: Status;

	dropdownList: TDropdownList;
	localState: TLocalState;
	props: TProps;
}
